import React, { useState, useRef } from "react";
import { IoEllipsisHorizontal } from "react-icons/io5";

const ActionsDropdown = ({ actions }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const buttonRef = useRef(null);

    const toggleDropdown = (e) => {
        e.stopPropagation(); // Prevent event propagation

        if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const menuWidth = 176; // ~w-44 in pixels

            setMenuPosition({
                top: rect.bottom + window.scrollY + 8,
                left: rect.right + window.scrollX - menuWidth,
            });
        }

        setIsOpen((prev) => !prev);
    };

    const handleActionClick = (e, action) => {
        e.stopPropagation(); // Prevent event propagation
        action.onClick();
        setIsOpen(false); // Close dropdown after action
    };

    return (
        <div className="relative inline-block text-left">
            {/* Dropdown Toggle Button */}
            <button
                type="button"
                onClick={toggleDropdown}
                ref={buttonRef}
                className="inline-flex items-center justify-center rounded-full border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-500 shadow-sm hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary/60 focus:ring-offset-1"
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                <IoEllipsisHorizontal className="w-4 h-4" />
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div
                    className="fixed w-44 origin-top-right rounded-xl border border-gray-100 bg-white shadow-xl z-[9999]"
                    style={{ top: menuPosition.top, left: menuPosition.left }}
                >
                    <ul className="py-1 text-sm text-gray-700">
                        {actions.map((action, index) => (
                            <li key={index}>
                                <button
                                    type="button"
                                    onClick={(e) => handleActionClick(e, action)}
                                    className="flex w-full items-center gap-2 px-4 py-2 hover:bg-gray-50 text-left"
                                >
                                    {action.icon && (
                                        <span className="flex h-5 w-5 items-center justify-center text-gray-500">
                                            {action.icon}
                                        </span>
                                    )}
                                    <span className="truncate">{action.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ActionsDropdown;